import { Box, Grid, Stack, Typography } from "@mui/material";
import templeIcon from "../../assets/temple-icon.png";
import locationIcon from "../../assets/loc-icon.png";
import ReactPlayer from "react-player";
import "./LiveDarshanView.scss";
import { useEffect, useRef } from "react";
import {
  getDeviceTypeFromUserAgent,
  trackCleavertapEvent,
} from "../../utils/analyics/analyticsHelper";
import { ANALYTICS_EVENTS } from "../../utils/analyics/analyticsEvents";

function LiveDarshanView(props: any) {
  const hasStartedRef = useRef<any>(null);
  const startTimeRef = useRef<any>(null);
  const ytCode =
    props.darshanDataFortemple && props.darshanDataFortemple.ytEmbedCode
      ? props.darshanDataFortemple.ytEmbedCode
      : "";
  const templeName = props?.darshanDataFortemple?.templeName ?? "";
  const city = props?.darshanDataFortemple?.city ?? "";
  const state = props?.darshanDataFortemple?.state ?? "";
  useEffect(() => {
    return () => {
      if (!startTimeRef.current) return;

      const watchDuration = Math.floor(
        (Date.now() - startTimeRef.current) / 1000,
      );

      const payload = {
        Live_Darshan_ID: ytCode,
        Temple_Name: templeName,
        Temple_ID: props?.darshanDataFortemple?.id ?? "",
        Device_Type: getDeviceTypeFromUserAgent(),
        Watch_Duration: watchDuration,
      };

      trackCleavertapEvent(ANALYTICS_EVENTS.Live_Darshan_Ended, payload)
    };
  }, []);

  const onPlayVideoHandler = (e: any) => {
    if (hasStartedRef.current) return;

    hasStartedRef.current = true;
    startTimeRef.current = Date.now();

    const payload = {
      Live_Darshan_ID: ytCode,
      Temple_Name: templeName,
      Temple_ID: props?.darshanDataFortemple?.id ?? "",
      Device_Type: getDeviceTypeFromUserAgent(),
    };
    trackCleavertapEvent(ANALYTICS_EVENTS.Live_Darshan_Started, payload);
  };

  return (
    <Box className="pageContainer liveDarshanPage">
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={1}>
          <Grid
            item
            xs={12}
            md={2}
            lg={3}
            xl={3}
            className="pagehdLeftBlock"
          ></Grid>
          <Grid item xs={12} md={8} lg={6} xl={6} className="pageCenterBlock">
            <Box className="templeDesInfo">
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="flex-start"
                spacing={2}
                className="infoRow"
              >
                <img
                  src={templeIcon}
                  className="templeIcon"
                  alt="Temple Icon"
                />
                <Typography>{templeName}</Typography>
              </Stack>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="flex-start"
                spacing={2}
                className="infoRow"
              >
                <img src={locationIcon} alt="Location Icon" />
                <Typography>
                  {city}, {state}
                </Typography>
              </Stack>
            </Box>

            {/* <Box className="templeDesInfo2">
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                
                className="infoRow"
              >
                <Typography>{templeName}</Typography>
                <img src={liner} className="omLiner" alt="Liner" />
              </Stack>
            </Box> */}
            <Box className="liveDarshanView">
              <ReactPlayer
                src={`https://www.youtube.com/embed/${ytCode}`}
                width="100wh"
                height="50vh"
                controls={true}
                muted={true}
                config={{ youtube: { color: "red" } }}
                onPlay={onPlayVideoHandler}
              />
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={2}
            lg={3}
            xl={3}
            className="pagehdRightBlock"
          ></Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default LiveDarshanView;
